import firebase from "../firebase";

export default function({ officeId, userId, messageId, conversationId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "markAsRead",
        data: { officeId, userId, messageId, conversationId }
    });
}
